import React, { Component } from "react";
import { ProductConsumer } from "../context";
import styled from "styled-components";
import { Link } from "react-router-dom";

export default class Sidecart extends Component {
  render() {
    return (
      <ProductConsumer>
        {(value) => {
          const { cartOpen, closeCart, cart, cartTotal } = value;
          return (
            <CartWrapper onClick={closeCart} show={cartOpen}>
              <ul>
                {cart.map((item) => {
                  return (
                    <li key={JSON.stringify(item)} className="cart-item mb-4">
                      <div className="mt-3">
                        <h6 className="text-uppercase text-title">
                          {item.count} X {item.nr}. {item.pName}
                        </h6>
                        <p>
                          {item.extratopping.map((topping) => {
                            return <span key={topping}>{topping}, </span>;
                          })}
                          <span>{item.dressing}</span>
                        </p>

                        <h6 className="text-title text-capitalize">
                          Beløb : {item.total} kr
                        </h6>
                      </div>
                    </li>
                  );
                })}
              </ul>
              <h4 className="text-capitalize text-main">
                Kurv total : {cartTotal} kr
              </h4>
              <div className="text-center my-5">
                <Link to="/cart" className="main-link">
                  Kurv Side
                </Link>
              </div>
            </CartWrapper>
          );
        }}
      </ProductConsumer>
    );
  }
}

const CartWrapper = styled.div`
  position: fixed;
  top: 60px;
  right: 0;
  width: 100%;
  height: 100%;
  background: var(--mainGrey);
  z-index: 1;
  transform: ${(props) => (props.show ? "translateX(0)" : "translateX(100%)")};
  border-left: 4px solid var(--primaryColor);
  transition: var(--mainTransition);
  @media (min-width: 576px) {
    width: 20rem;
  }
  overflow: scroll;
  padding: 2rem;
  ul {
    padding: 0 !important;
  }
  .cart-item {
    list-style-type: none;
  }
`;
